import { APIGet, APIPut } from "api/protocols";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/facility/settings/payment";

interface IGetPaymentSettingsResponse {
  id: number;
  facility_id: number;
  refund_limit_daily: number;
  refund_limit_weekly: number;
}

interface IPutPaymentSettings {
  id: number;
  refund_limit_daily: number;
  refund_limit_weekly: number;
}

interface IPutPaymentSettingsResponse {
  id: number;
  facility_id: number;
  refund_limit_daily: number;
  refund_limit_weekly: number;
  created_at: string;
  updated_at: string;
  deleted_at: string;
}

export function GetPaymentSettings(params: null, useGlobalLoader: boolean) {
  return APIGet<IGetPaymentSettingsResponse>(baseUrl, params, useGlobalLoader);
}

export function PutPaymentSettings(params: IPutPaymentSettings, useGlobalLoader: boolean) {
  return APIPut<IPutPaymentSettingsResponse>(baseUrl, params, useGlobalLoader);
}
